import type { ReactStoryblokComponent } from "types/storyblok";
import { SideBarHeading } from "components";
import ContentAdapter from "../Content/Content";
import type { HelpQuestionAdapterProps } from ".";

const HelpQuestion = ({ blok }: ReactStoryblokComponent<HelpQuestionAdapterProps>) => {
  const { _uid, question, answer, component } = blok;
  const contentAdapterBlok = {
    _uid,
    content: answer,
    component,
  };
  return (
    <>
      <SideBarHeading text={question} />
      <ContentAdapter blok={contentAdapterBlok} />
    </>
  );
};

export default HelpQuestion;
